/* eslint-disable */
import React, { useState } from "react";
import "../../Assets/css/dynamicTabSwitcher.css";

// const tabMap = {
//   firm_l1: "Firm L1",
//   reg_l1: "Reg L1",
//   reg_l2: "Reg L2",
// };

// const tabs = Object.keys(tabMap);

const DynamicTabSwitcher = ({
  onTabChange,
  disabledTabs = [],
  wrapperClassName,
  tabMap,
  activeTab,
}) => {
  const tabs = Object.keys(tabMap);

  const handleTabs = (tab) => {
    if (!disabledTabs.includes(tab)) {
      if (onTabChange) onTabChange(tab);
    }
  };

  const activeIndex = tabs.indexOf(activeTab);

  return (
    <div className={`dynamic-wrapper ${wrapperClassName}`}>
      <div className={`tabs-section tab-${activeIndex}`}>
        {tabs.map((tab) => {
          const isDisabled = disabledTabs.includes(tab);
          return (
            <div
              key={tab}
              className={`grid-tab-wrapper ${isDisabled ? "disabled-tab" : ""}`}
              onClick={() => handleTabs(tab)}
            >
              <div
                className={`grid-tab ${activeTab === tab ? "active-tab" : ""}`}
              >
                <span>{tabMap[tab]}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DynamicTabSwitcher;
